import { create } from 'zustand'

const useTableStore = create((set) => ({
    columnWidths: {},
    setColumnWidths: (columnWidths) => set(() => ({ columnWidths })),
    updateColumnWidth: (tableName, key, width) => set((state) => ({
        columnWidths: {
            ...state.columnWidths,
            [tableName]: { ...(state.columnWidths[tableName] || {}), [key]: width }
        }
    })),
}))

export default useTableStore